'use strict';

import { Component } from 'react';
import Style from './Dropdown.cssmodule.less';
import React from 'react';

/**
 *
 * @param {String} placeholder 최초 헤더타이틀에 들어갈 문자열
 * @param {Array<String>} list 선택란에 넣을 리스트
 * @param {Object} option width: 276px 기본.
 */
export default class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.Style = Style;
        this.state = {
            isListVisible: false,
            headerContent: props.placeholder || '',
        };

        this.toggleDropdownList = this.toggleDropdownList.bind(this);
        this.makeItemList = this.makeItemList.bind(this);
    }

    toggleDropdownList() {
        this.setState({ isListVisible: !this.state.isListVisible });
    }

    /**
     * 아이템이 클릭되면 re-render 와 함께
     * 사용처 확인. bind 가 아닌 인자를 넘겨받기 위해 arrow function 으로 작성됨.
     *
     * @see makeItemList
     * @param item
     */
    handleItemClicked(item) {
        const { onItemChange } = this.props;
        if (onItemChange) {
            onItemChange(item);
        }

        this.setState({
            headerContent: item,
            isListVisible: false,
        });
    }

    makeItemList() {
        const style = this.Style;

        return (
            <div>
                {this.props.list.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className={style.item}
                            onClick={() => {
                                this.handleItemClicked(item);
                            }}
                        >
                            {item}
                        </div>
                    );
                })}
            </div>
        );
    }

    render() {
        const style = this.Style;
        const { isListVisible, headerContent } = this.state;

        return (
            <div
                className={style.dropdown}
            >
                <div className={`${style.header} ${isListVisible && style.active}`} onClick={this.toggleDropdownList}>
                    <div
                        className={style.headerTitle}
                    >
                        {headerContent}
                    </div>
                    <div
                        className={style.arrowButton}
                    />
                </div>

                {isListVisible && (
                    <div className={style.list}>
                        {this.makeItemList()}
                    </div>
                )}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./components/CommonSet/Dropdown.js